import React, { Component } from 'react';
import { Icon } from '../../../ui-kit';
import '../styles/_options-menu.scss';













export default class OptionsMenu extends Component {


  constructor(props) {
    super(props);

    this.state = {
      menuOpen: false
    };
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClick);
  }

  setMenuRef = (node) => {
    this._menuRef = node;
  };

  toggleMenu = () => {
    const { setIconLabelsVisibility } = this.props;

    this.setState(({ menuOpen }) => ({ menuOpen: !menuOpen }), () => {
      const { menuOpen } = this.state;

      setIconLabelsVisibility(!menuOpen);

      if (menuOpen) {return void document.addEventListener('mousedown', this.handleClick);}
      document.removeEventListener('mousedown', this.handleClick);
    });
  };

  handleClick = (event) => {
    const { menuOpen } = this.state;

    if (this._menuRef.contains(event.target) || !menuOpen) {return;}
    this.toggleMenu();
  };

  render() {
    const { options, selectedIndex, children, disabled } = this.props;
    const { menuOpen } = this.state;

    if (disabled || !options || !options.length) {return children;}

    return (
      <div ref={this.setMenuRef} className="player-options-menu">
        {React.cloneElement(children, { onClick: this.toggleMenu })}
        {
        menuOpen ?

        <div className="player-options-menu__inner">
                {options.map((option, index) =>
          <React.Fragment key={option.label}>
                    {option.hasDivider &&
            <hr className="player-options-menu__divider" />}

                    <button
              type="button"
              className={`player-options-menu__option${option.isAction ? ' player-options-menu__option--action' : ''}`}
              onClick={option.onClick}>

                      <p>
                        {option.label}
                        {option.superscript ?

                <sup>
                              {option.superscript}
                            </sup> :
                null}
                      </p>
                      {selectedIndex === index ? <Icon name="success" color="white" size={10} /> : null}
                    </button>
                  </React.Fragment>
          )}
              </div> :

        null}

      </div>);

  }
}